// Modules
import React, { Component } from 'react';

// Styles
import './Week.scss'


// Components
import Day from '../Day';


interface IProps {
    className?:any
    weekDays:Date[];
    enabledDates: (string | Date)[];
    activeDate: Date | null;
    rangeStartDate?: string;
    rangeEndDate?: string;
}

interface IState {

}


class Week extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
    }

    getDateStamp(date:Date) {
        return (`${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`);
    }

    getEmptyStamp() {
        return (`${this.props.weekDays[0].getFullYear()}-${this.props.weekDays[0].getMonth()}`);
    }

    getArr(num: number){

        let arr = []
        for(let i = 0; i< num; i++){
            arr.push(1)
        }
        return arr
    }

    render() {
        //let dailyPoints: number;
        let firstDay = this.props.weekDays[0].getDay();
        let lastDay = this.props.weekDays[this.props.weekDays.length - 1].getDay();
        let blankStart = firstDay;
        let blankEnd = 6 - lastDay;
        
        return (
            <tr className={this.props.className}>
                {this.getArr(blankStart).map((_, index:number) =>
                    <td key={"empty-start-" + this.getEmptyStamp() + '-' + index}></td>
                )}

                {this.props.weekDays.map((day:Date) => {
                    let dayEnabled:boolean = false;
                    let dailyPoints: any = "";
                    
                    this.props.enabledDates.map((obj: any)=> {
                        if (day.valueOf() === obj.dates.valueOf()) {
                            dayEnabled = true
                            dailyPoints = obj.points
                            return {dayEnabled, dailyPoints}
                        }
                    })

				    const dayActive = this.props.activeDate !== null &&
                    this.props.activeDate.valueOf() === day.valueOf();

                    return (
                      <td
                          key={"day-" + this.getDateStamp(day)}
                          className="week-day"
  						  aria-selected={dayActive}
                      >
	                      <Day
                                day={day}
                                dayEnabled={dayEnabled}
                                activeDate={this.props.activeDate}
                                pointsData={dailyPoints}
                                rangeStartDate={this.props.rangeStartDate}
                                rangeEndDate ={this.props.rangeEndDate} 
	                      />

                      </td>
                    );
                })}
                {this.getArr(blankEnd).map((_, index:number) =>
                    <td key={"empty-end-" + this.getEmptyStamp() + '-' + index}></td>
                )}
            </tr>
        );
    }
}

export default Week;
